import type { RouteConfig } from '@hs/shared';
import { MainLayout } from '@/layouts';
import HomePage from '@/pages/home';
import ProductsPage from '@/pages/products';
import HelpPage from '@/pages/help';
import ContactPage from '@/pages/contact';
import LoginPage from '@/pages/auth/login';
import RegisterPage from '@/pages/auth/register';
import InviterRegisterPage from '@/pages/auth/inviter';
import WeChatOpenTestPage from '@/pages/wechat-open-test';

/**
 * Home 应用路由配置
 * 
 * 特性：
 * - 使用 meta.requiresAuth 声明是否需要认证
 * - 支持嵌套路由结构，便于未来扩展
 * - 路由层只做认证检查，不做权限检查
 * - 使用 MainLayout 作为主布局
 */
export const homeRoutes: RouteConfig[] = [
  {
    path: '/',
    element: <MainLayout />,
    meta: {
      title: '首页',
      requiresAuth: false,
    },
    children: [
      {
        path: '',
        index: true,
        element: <HomePage />,
        meta: {
          title: '首页',
        },
      },
      {
        path: 'products',
        element: <ProductsPage />,
        meta: {
          title: '定价',
          requiresAuth: false,
        },
      },
      {
        path: 'help',
        element: <HelpPage />,
        meta: {
          title: '指南',
          requiresAuth: false,
        },
      },
      {
        path: 'contact',
        element: <ContactPage />,
        meta: {
          title: '联络',
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/login',
    element: <LoginPage />,
    meta: {
      title: '登录',
      requiresAuth: false,
    },
  },
  {
    path: '/inviter',
    element: <InviterRegisterPage />,
    meta: {
      title: '邀请注册',
      requiresAuth: false,
    },
  },
  {
    path: '/register',
    element: <RegisterPage />,
    meta: {
      title: '注册',
      requiresAuth: false,
    },
  },
  {
    path: '/wechat-open-test',
    element: <WeChatOpenTestPage />,
    meta: {
      title: '开放平台登录测试',
      requiresAuth: false,
    },
  },
];

